/**
 * Default format for export actions.
 *
 * @namespace tmrDefaultExportFormat
 * @type {ngConstant}
 */
export const constant = ['tmrDefaultExportFormat', 'csv']
